import {
  MenuItem,
  SchoolSportSeason,
  Sport,
  State,
  Team,
  TeamDataAvailability,
  TeamSettings
} from '@maxpreps/apiserviceclients/apiModels';
import { createContext, useContext } from 'react';
import { IChildrenProps } from '../models/utilTypes';

interface ITeamSettings
  extends Pick<TeamSettings, 'rosterUpdatedOn' | 'areVolunteersDisallowed'> {}

export interface ITeamContext {
  data: Team;
  teamMenuData: MenuItem[];
  sportData: Sport;
  teamSeasonPickerData: SchoolSportSeason[];
  teamPhotoUrl: string;
  tda: TeamDataAvailability;
  stateData: State;
  isAllTimeRosterEnabled: boolean;
  mostRecentAdminGenderSportSeasonLevel: SchoolSportSeason;
  mostRecentPublicGenderSportSeasonLevel: SchoolSportSeason;
  teamSettings: ITeamSettings;
}

const TeamContext = createContext<ITeamContext>({
  data: {} as any,
  teamMenuData: [],
  sportData: {} as any,
  teamSeasonPickerData: [],
  teamPhotoUrl: '',
  stateData: {} as any,
  isAllTimeRosterEnabled: false,
  mostRecentAdminGenderSportSeasonLevel: {} as any,
  mostRecentPublicGenderSportSeasonLevel: {} as any,
  teamSettings: {} as any,
  tda: {} as any
});

TeamContext.displayName = 'TeamContext';

interface ITeamContextProviderProps extends IChildrenProps {
  initContextValue: ITeamContext;
}

const TeamContextProvider: React.FC<ITeamContextProviderProps> = ({
  initContextValue,
  children
}) => (
  <TeamContext.Provider value={initContextValue}>
    {children}
  </TeamContext.Provider>
);

const useTeamContext = () => useContext(TeamContext);

export { TeamContextProvider, useTeamContext as default };

